<template>
  <nv-page header="Force Update Application Templates">
    <template slot="filters">
      <nv-table-filters
        ref="applied-filters"
        :value="formattedFilters"
        @clear="$refs['filter-sheet'].clearFilters()"
      >
        <filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      class="elevation-1"
    >
      <template #item="{ item }">
        <tr style="cursor: pointer" @click="selectTemplate(item)">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.status | humanize }}</td>
          <td>{{ item.country_code }}</td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card v-if="selectedTemplate">
        <v-card-title>
          <span class="text-h5">Force Update: {{ selectedTemplate.name }}</span>
          <span class="text-caption ml-2">(ID: {{ selectedTemplate.id }})</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-tabs v-model="activeTab">
                  <v-tab>Parameters</v-tab>
                  <v-tab>SDK Configurations</v-tab>

                  <v-tab-item>
                    <force-update-parameter-form
                      :template-id="selectedTemplate.id"
                      @success="handleUpdateSuccess"
                      @error="handleUpdateError"
                    />
                  </v-tab-item>

                  <v-tab-item>
                    <force-update-sdk-config-form
                      :template-id="selectedTemplate.id"
                      @success="handleUpdateSuccess"
                      @error="handleUpdateError"
                    />
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nv-page>
</template>

<script>
import HTTP from '@/api/dog';
import { formatFilters } from '@/helpers/filters';
import { TableMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import ForceUpdateParameterForm from '@/components/application_templates/ForceUpdateParameterForm.vue';
import ForceUpdateSDKConfigForm from '@/components/application_templates/ForceUpdateSDKConfigForm.vue';
import FilterSheet from '@/components/application_templates_force_update/FilterSheet.vue';

const headers = [
  { text: 'ID', sortable: false, value: 'id' },
  { text: 'Name', sortable: false, value: 'name' },
  { text: 'Status', sortable: false, value: 'status' },
  { text: 'Country Code', sortable: false, value: 'country_code' },
];

export default {
  name: 'ForceUpdateTemplatesList',
  components: {
    ForceUpdateParameterForm,
    // eslint-disable-next-line vue/no-unused-components
    ForceUpdateSDKConfigForm,
    FilterSheet,
  },
  mixins: [TableMixin],
  data() {
    return {
      headers,
      selectedTemplate: null,
      dialog: false,
      activeTab: 0,
      countries: [],
    };
  },
  computed: {
    formattedFilters() {
      return formatFilters(this.tableFilters, this.countries);
    },
  },
  created() {
    this.enumFetch(HTTP, {
      countries: '/countries?per_page=300',
    });
  },
  methods: {
    enumFetch,
    formatFilters,
    tableFetch() {
      this.paginateTableData(HTTP, '/applications/templates');
    },
    setTableFilters(filters) {
      this.tableFilters = { ...filters };
    },
    selectTemplate(template) {
      this.selectedTemplate = template;
      this.dialog = true;
      this.activeTab = 0;
    },
    closeDialog() {
      this.dialog = false;
      this.selectedTemplate = null;
      this.activeTab = 0;
    },
    handleUpdateSuccess() {
      // Success is already handled by the form component with flash message
      this.closeDialog();
    },
    handleUpdateError() {
      // Error is already handled by the form component with error display
    },
  },
};
</script>

<style scoped>
tr {
  cursor: pointer;
}
</style>
